import XIcon from '../icons/xIcon'

export default function LoginErrorMessage() {
  return (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <XIcon />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Invalid email or password
          </h3>
        </div>
      </div>
    </div>
  )
}
